var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile && !_vm.isWebviewRoute)?_c('div',{staticClass:"customer-btn",on:{"click":_vm.goLive}},[_c('img',{attrs:{"src":require("@assets/images/live_chat.png"),"mode":"widthFix"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }